import { useCallback } from 'react';
import { useCachedResource } from './useCachedResource'; // Adjust import path
import { appConfig } from '@/lib/AppConfig';
import { FeatureService } from '@/services/FeatureService';

interface Site {
  name: string;
}

export const useFeatureName = (featureId?: string) => {
  // Memoize the fetch function to preserve the context
  const fetchFeature = useCallback(async (id: string) => {
    return await FeatureService.getById(id);
  }, []);

  const { data, isLoading, error } = useCachedResource<Site>(
    featureId,
    appConfig.resourceTypes.feature,
    fetchFeature
  );

  return { featureName: data?.name || null, isLoading, error };
};